import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QuerySearchTemplatesArgs,
  QuerySearchTemplatesSuggestionsArgs,
  SearchSuggestionsOutput,
  SearchTemplatesOutput,
  MutationTemplateDeleteArgs,
  MutationTemplateCreateArgs,
  MutationTemplateUpdateArgs,
  Template,
} from "types/generated";

type SearchTemplatesData = {
  searchTemplates: SearchTemplatesOutput;
};

export const SEARCH_TEMPLATES: TypedDocumentNode<SearchTemplatesData, QuerySearchTemplatesArgs> =
  gql`
    query SearchTemplates($input: SearchInput!) {
      searchTemplates(input: $input) {
        edges {
          cursor
          node {
            allowedActions
            canDelete
            createdAt
            description
            deploymentsCount
            id
            labels
            latestVersion {
              id
              version
            }
            name
            space {
              id
              name
              accessLevel
            }
            ulid
            updatedAt
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  `;

type SearchTemplatesSuggestionsData = {
  searchTemplatesSuggestions: SearchSuggestionsOutput;
};

export const SEARCH_TEMPLATES_SUGGESTIONS: TypedDocumentNode<
  SearchTemplatesSuggestionsData,
  QuerySearchTemplatesSuggestionsArgs
> = gql`
  query SearchTemplatesSuggestions($input: SearchSuggestionsInput!) {
    searchTemplatesSuggestions(input: $input) {
      filteredCount
      fields {
        name
        orderable
        filterable
        type
        possibleValuesBoolean {
          values
          counts
        }
        possibleValuesEnum {
          values
          counts
        }
        possibleValuesString {
          values
          counts
        }
        possibleValuesHierarchy {
          values {
            id
            parentId
            displayValue
          }
          counts
        }
      }
    }
  }
`;

type DeleteTemplateData = {
  templateDelete: Pick<Template, "id" | "name">;
};

export const DELETE_TEMPLATE: TypedDocumentNode<DeleteTemplateData, MutationTemplateDeleteArgs> =
  gql`
    mutation TemplateDelete($id: ID!) {
      templateDelete(id: $id) {
        id
        name
      }
    }
  `;

type CreateTemplateData = {
  templateCreate: Pick<Template, "id" | "name">;
};

export const CREATE_TEMPLATE: TypedDocumentNode<CreateTemplateData, MutationTemplateCreateArgs> =
  gql`
    mutation TemplateCreate($input: TemplateCreateInput!) {
      templateCreate(input: $input) {
        id
        name
      }
    }
  `;

type UpdateTemplateData = {
  templateUpdate: Pick<Template, "id" | "name" | "description" | "createdAt" | "space" | "labels">;
};

export const UPDATE_TEMPLATE: TypedDocumentNode<UpdateTemplateData, MutationTemplateUpdateArgs> =
  gql`
    mutation UpdateTemplate($id: ID!, $input: TemplateUpdateInput!) {
      templateUpdate(id: $id, input: $input) {
        id
        name
        description
        createdAt
        space {
          id
          name
          accessLevel
        }
        labels
      }
    }
  `;
